/* file description */
import { cloneDeep } from 'lodash';
import type { UseOnValuesChange } from './type';

export const useOnValuesChange: UseOnValuesChange = ({
  formInitData,
  onValuesChange,
}) => {
  return {
    mergeValuesChange: (changedValues, allValues) => {
      if (onValuesChange) {
        const values = cloneDeep(formInitData?.value) || {};
        values.values = allValues;
        // onValuesChange(changedValues, { RECORD: values, ...allValues });
        onValuesChange(changedValues, { ...allValues });
      }
    },
  };
};

